<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    v-b-tooltip.hover.v-info.top="$t(i18nHoverVariable)"
    variant="flat-info"
    class="btn-icon rounded-circle"
    @click="$emit('clicked')"
  >
    <feather-icon icon="UploadIcon" />
  </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'UploadButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    i18nHoverVariable: {
      type: String,
      default: 'declaration.upload_new_version',
    },
  },
}
</script>

<style scoped>

</style>
